// <s-card-add data-variant-id="123" data-added-label="Added" data-error-label="…">
// Quantity stepper + Add button for product cards that cannot hold a product <form>
// (search results live inside the live search form). Adds through the standard
// cart action so the order drawer and header count refresh on their own.
// Input/change/keydown events stop here so the surrounding live search never re-runs.
class SCardAdd extends HTMLElement {
  #busy = false;

  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = '1';
    const stop = (e) => e.stopPropagation();
    this.addEventListener('input', stop);
    this.addEventListener('change', stop);
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        this.#add();
      }
    });
    this.addEventListener('click', (e) => {
      const step = e.target.closest('[data-step]');
      if (step) {
        e.preventDefault();
        this.#step(Number(step.dataset.step));
        return;
      }
      if (e.target.closest('[data-card-add]')) {
        e.preventDefault();
        this.#add();
      }
    });
  }

  get #input() {
    return this.querySelector('input[type="number"]');
  }

  #step(delta) {
    const input = this.#input;
    if (!input) return;
    const min = Number(input.min) || 1;
    const next = Math.max(min, (Number(input.value) || min) + delta);
    input.value = String(next);
  }

  async #add() {
    if (this.#busy) return;
    const button = this.querySelector('[data-card-add]');
    const label = button?.querySelector('[data-label]');
    const status = this.querySelector('[data-status]');
    const quantity = Math.max(1, Math.floor(Number(this.#input?.value) || 1));
    this.#busy = true;
    button?.setAttribute('aria-disabled', 'true');
    button?.classList.add('opacity-60', 'cursor-wait');
    if (status) status.textContent = '';
    try {
      const result = await window.Shopify?.actions?.updateCart?.(
        { lines: [{ merchandiseId: String(this.dataset.variantId), quantity }] },
        { event: { context: 'product', detail: { source: 's-card-add' } } }
      );
      const error = result?.userErrors?.[0]?.message;
      if (error) {
        if (status) status.textContent = error;
        return;
      }
      if (label) {
        const original = label.textContent;
        label.textContent = this.dataset.addedLabel || original;
        button?.classList.add('bg-success');
        setTimeout(() => {
          label.textContent = original;
          button?.classList.remove('bg-success');
        }, 1800);
      }
      const sr = this.querySelector('[data-sr]');
      if (sr) sr.textContent = this.dataset.addedLabel || '';
    } catch (_) {
      if (status) status.textContent = this.dataset.errorLabel || '';
    } finally {
      this.#busy = false;
      button?.removeAttribute('aria-disabled');
      button?.classList.remove('opacity-60', 'cursor-wait');
    }
  }
}

if (!customElements.get('s-card-add')) customElements.define('s-card-add', SCardAdd);
